function isTraceEnabled(): boolean {
  if (!import.meta.env.DEV) return false
  try {
    return globalThis.localStorage?.getItem('chat:trace') === '1'
  } catch {
    return false
  }
}

export function chatTrace(scope: string, event: string, payload?: Record<string, unknown>) {
  if (!isTraceEnabled()) return
  const now = new Date().toISOString()
  if (payload) {
    console.debug(`[chat-trace][${now}][${scope}] ${event}`, payload)
    return
  }
  console.debug(`[chat-trace][${now}][${scope}] ${event}`)
}

